<div id="containerBot" class="botContainer fade" >

  <!--START: THIS IS THE HEADER -->
  <div class="toolbar" role="banner">
    <span class="tituloBienvenida"> Asistente Cementos Moctezuma </span>
  </div>
  <!--END:   THIS IS THE HEADER -->

  <!--START:   THIS IS THE BODY -->
  <div class="content scroll" #botOrganon id="botOrganon">

  </div>
  <!--END:   THIS IS THE BODY -->

  <!--START: THIS IS THE FOOTER -->
  <div class="containerForm">
    <button *ngIf="CONFIRM_FORM_VALIDATOR" class="nextButton" (click)="createConfirmStaticMessages('confirm')" [disabled]="FORM_VALIDATOR==false">Siguiente</button>
    <button *ngIf="CONFIRM_TONELAJE_VALIDATOR" class="nextButton" (click)="createConfirmStaticMessages('tonelaje')">Siguiente</button>
    <button *ngIf="CONFIRM_M3_VALIDATOR" class="nextButton" (click)="createConfirmStaticMessages('m3')">Siguiente</button>
    <button *ngIf="CONFIRM_SELECTABLE_BUTTON_VALIDATOR" [disabled]="selectedButtonsArray.length==0" class="nextButton" (click)="selectedProductsRoutine()">Siguiente</button>
  </div>
  <!--END:   THIS IS THE FOOTER -->
</div>
